//  SidebarMatchesForClient

import React, { useState, useEffect } from "react";
import "../Styles/SidebarMatches.css"; // Custom CSS file
import { calculateAge, getDefaultProfileIcon } from "../utils/commonFunctions";
import { get_access_request, update_match_status } from "../api/serverWrapper";
import ForwardClientPopup from "./ForwardClientPopup";

const tabs = ["New", "Saved", "Forwarded", "Approved"];

export const New = 1;
export const UnLiked = 2;
export const Saved = 3;
export const Shared = 4;
export const Approved = 5;

const SidebarMatchesForClient = ({
  data,
  allIcons,
  loadMathesData,
  client,
  MoveToApprovedClient,
  handleProfileId,
  setDisplayActiveTabs,
  setActiveTabforProfile,
}) => {
  const [activeTab, setActiveTab] = useState("New");
  const [searchQuery, setSearchQuery] = useState("");
  const [openForwardClientPopup, setOpenForwardClientPopup] = useState(false);
  const [profileId, setProfileId] = useState(null);

  useEffect(() => {
    for (let index = 0; index < data.length; index++) {
      getAccesRequest(client.ProfileId, data[index].ProfileId);
    }
  }, []);

  const filterDataByTab = () => {
    let filtered = [];

    if (activeTab === "New") {
      filtered = data.filter(
        (item) =>
          [New].includes(item.MatchInfo?.C1AgentStatus) &&
          item.MatchInfo?.Client1Status !== Approved &&
          item.MatchInfo?.Client1Status !== Saved,
      );
    } else if (activeTab === "Forwarded") {
      filtered = data.filter(
        (item) =>
          [Shared].includes(item.MatchInfo?.C1AgentStatus) &&
          item.MatchInfo?.Client1Status !== Approved,
      );
    } else if (activeTab === "Saved") {
      filtered = data.filter((item) => item.MatchInfo?.Client1Status === Saved);
    } else if (activeTab === "Approved") {
      filtered = data.filter(
        (item) => item.MatchInfo?.Client1Status === Approved,
      );
    } else {
      filtered = data;
    }

    // Apply search filter
    if (searchQuery.trim()) {
      const lowerQuery = searchQuery.toLowerCase();
      filtered = filtered.filter((item) => {
        const fullName = `${item?.User?.FirstName ?? ""} ${
          item?.User?.LastName ?? ""
        }`.toLowerCase();
        return fullName.includes(lowerQuery);
      });
    }

    return filtered;
  };

  const handleIconPress = (icon, MatchId, item) => {
    setProfileId(item);
    if (icon === "like_icon") {
      let Status = Approved; //Approved
      updateMatchStatus(MatchId, Status);
      // setDisplayActiveTabs("Approved Matches");
      // setActiveTabforProfile("approved");
      setActiveTab("Approved");
      // MoveToApprovedClient();
    }
    if (icon === "dislike_icon") {
      let Status = UnLiked; //UnLiked
      updateMatchStatus(MatchId, Status);
    }
    if (icon === "share_icon") {
      // let C1AgentStatus = Shared; //saved
      // updateMatchStatus(MatchId, C1AgentStatus);
      // setActiveTab("Forwarded to client");
      handelForwardClientPopup();
    }
    if (icon === "copy_icon") {
      console.log("MatchId", MatchId);
      let Client1Status = Saved; //Saved
      updateMatchStatus(MatchId, Client1Status);
      setActiveTab("Saved");
    }
  };

  const handelForwardClientPopup = () => {
    setOpenForwardClientPopup(!openForwardClientPopup);
  };
  const [loading, setLoading] = useState(false);
  const updateMatchStatus = async (MatchId, Status) => {
    try {
      setLoading(true);

      const data = {
        MatchId,
        Client1Status: Status,
      };

      const res = await update_match_status(data);

      if (res.code === 200) {
        await loadMathesData(client?.ProfileId);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const [AccesRequestStatus, setAccesRequestStatus] = useState({});
  const getAccesRequest = async (ProfileId, ToProfileId) => {
    console.log(ProfileId, ToProfileId);

    try {
      let resp = await get_access_request(ProfileId, ToProfileId);
      setAccesRequestStatus((prev) => ({
        ...prev,
        [ToProfileId]: resp?.data?.IsAccepted ?? null,
      }));
    } catch (error) {
      console.error("getAccesRequest error:", error);
    }
  };

  const getVisibleIcons = () => {
    if (activeTab === "New") {
      const { share_icon, ...filteredIcons } = allIcons;
      return filteredIcons;
    }

    if (activeTab === "Saved") {
      // Omit copy_icon in Saved tab
      const { copy_icon, share_icon, ...filteredIcons } = allIcons;
      return filteredIcons;
    }

    if (activeTab === "Forwarded to client") {
      const { like_icon, ...filteredIcons } = allIcons;
      return filteredIcons;
    }

    if (activeTab === "Approved") {
      const { like_icon, share_icon, ...filteredIcons } = allIcons;
      return filteredIcons;
    }

    // Default: show all icons
    return allIcons;
  };

  const handleClick = (id) => {
    handleProfileId(id);
  };

  const filteredMatches = filterDataByTab();

  const perfectMatches = filteredMatches.filter(
    // (item) => item.MatchInfo?.MatchLevel === 1,
    (item) => item.MatchInfo?.IsPerfectMatch === true,
  );

  const otherMatches = filteredMatches.filter(
    // (item) => item.MatchInfo?.MatchLevel === 2,
    (item) => item.MatchInfo?.IsPerfectMatch !== true,
  );

  const renderMatchCards = (matches) =>
    matches.map((item, i) => (
      <div
        key={i}
        className="match-card click-effect"
        onClick={() => handleClick(item.ProfileId)}
      >
        <div className="match-top">
          <img
            src={
              item?.User?.ProfilePhotoUrl || getDefaultProfileIcon(item?.User)
            }
            alt="Profile"
            className={
              item.IsPhotoVisible || AccesRequestStatus[item.ProfileId] === 2
                ? "match-img"
                : "match-img blur-profile-img"
            }
          />

          <div>
            <div
              className={
                item.MatchInfo?.C1AgentStatus === New
                  ? "client-name-for-like"
                  : "client-name"
              }
            >
              {item?.User?.FirstName} {item?.User?.LastName},{" "}
              {calculateAge(item?.User?.DOB)}
            </div>

            <div className="client-agent"></div>

            {item.MatchInfo?.C1AgentStatus !== New && (
              <div className="client-agent-no"></div>
            )}
          </div>
        </div>

        {item.MatchInfo?.C1AgentStatus === New && (
          <div className="match-criteria">
            Matched on: Caste | Appearance | Salary req | 3 more +
          </div>
        )}

        <div className="hover-icons">
          {Object.entries(getVisibleIcons()).map(
            ([iconKey, iconSrc], index) => (
              <button
                key={index}
                className="icon-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleIconPress(iconKey, item.MatchInfo.MatchId, item);
                }}
              >
                <img src={iconSrc} alt={iconKey} />
              </button>
            ),
          )}
        </div>
      </div>
    ));

  const getEmptyMessage = () => {
    if (activeTab === "New")
      return " No profiles found, Refine your preferences to expand your search";
    if (activeTab === "Saved") return "No saved profiles found.";
    return "No profiles found.";
  };

  return (
    <div className="sidebar-container ms-2">
      <div id="custom-toast-forward">Forwarded successfully!</div>
      {/* Tabs */}
      <div className="tabs-client">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-btn-client ${
              activeTab === tab ? "active" : ""
            } click-effect`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Search */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search match"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <span className="search-icon">
          <svg
            width="21"
            height="19"
            viewBox="0 0 21 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="8.35998"
              cy="8.18786"
              r="6.04251"
              transform="rotate(19.726 8.35998 8.18786)"
              stroke="#5E5C68"
              stroke-width="0.720124"
            />
            <path
              d="M12.2871 13.6152L15.6146 18.1292"
              stroke="#5E5C68"
              stroke-width="1.44025"
              stroke-linecap="round"
            />
          </svg>
        </span>
      </div>

      {/* Match List */}
      <div className="match-list">
        {loading ? (
          <div className="loading-state skeleton">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="skeleton-card">
                <div className="skeleton-left" />
                <div className="skeleton-right">
                  <div className="skeleton-line short" />
                  <div className="skeleton-line" />
                  <div className="skeleton-line small" />
                </div>
              </div>
            ))}
          </div>
        ) : filteredMatches.length === 0 ? (
          <div className="no-data-message">{getEmptyMessage()}</div>
        ) : activeTab === "New" ? (
          <>
            {perfectMatches.length > 0 && (
              <>
                <div className="group-matchs-title">Perfect Matches</div>

                {renderMatchCards(perfectMatches)}
              </>
            )}

            {otherMatches.length > 0 && (
              <>
                <div className="group-matchs-title mt-3">
                  You can also check
                </div>

                {renderMatchCards(otherMatches)}
              </>
            )}
          </>
        ) : (
          renderMatchCards(filteredMatches)
        )}
      </div>
      {openForwardClientPopup && data && (
        <ForwardClientPopup
          clients={data}
          profileId={profileId}
          handelForwardClientPopup={handelForwardClientPopup}
        />
      )}
    </div>
  );
};

export default SidebarMatchesForClient;
